/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  ISectionsMethods, SectionsService,
  ISectionOptionsMethods,
  SectionOptionsService,
  CostumeInventoryService,
  ICostumeInventoryMethods,
  IPresentationsMethods,
  PresentationsService,
  IGetTrackHistoryMethods,
  GetTrackHistoryService
} from "./components";

export type InventoryControlReportPageAgent = IHeaderMethods &
  ISettingsMethods &
  IPresentationsMethods &
  IStaticPageContentMethods &
  ISectionsMethods &
  ISectionOptionsMethods &
  IGetTrackHistoryMethods &
  ICostumeInventoryMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new PresentationsService(),
    new SectionsService(),
    new SectionOptionsService(),
    new CostumeInventoryService(),
    new GetTrackHistoryService(),
  ];
};

export const getAgent = () => {
  return createAgent<InventoryControlReportPageAgent>({
    plugins: getPlugins(),
  });
};
